<template>
  <div class="flex items-center pt-[14px] pb-2">
    <a href="/" class="flex items-center h-full">
      <img
        src="https://s3.amazonaws.com/ma-content/images/2024/logo-light.png"
        alt="Motion Array"
        title="Motion Array"
        style="max-width: 120px" />
    </a>
    <SearchBlock class="ml-5 mr-6 w-full max-w-[400px]" ref="searchBlock" />
    <UserLinks
      v-if="!loading"
      class="ml-auto"
    />
  </div>
</template>

<script>
import SearchBlock from './search-block.vue';
import UserLinks from './user-links';

export default {
  components: { SearchBlock, UserLinks },
  data() {
    return {
      timeout: null,
      loading: true,
    };
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.loading = false;
    }, 100);
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  },
};
</script>

<style>
.pt-\[14px\] {
  padding-top: 14px;
}
.max-w-\[400px\] {
  max-width: 400px;
}
</style>
